import React, { useCallback } from "react"
import { Translate } from "utils/i18n-shim"
import { openDialog } from "./store"

export const useEditActivityNoteAction = () => {
  return useCallback((activityNote, japCustomerId) => {
    return {
      label: <Translate value="edit" />,
      onClick: () => openDialog({ activityNote, japCustomerId })
    }
  }, [])
}
